import React, { memo } from "react";
import { FaPen, FaPlus } from "react-icons/fa";
import { Handle } from "reactflow";

import "./index.css";
import { ValidatorFn } from "../../../helpers/validationConnector";
import { NodeHeader } from "../../Elements/NodeHeader";
import { NodeRef } from "../../Elements/NodeRef";

export default memo(({ data, ...rest }) => {
	return (
		<>
			<NodeRef nodeRef={data.ref} />
			<Handle type="target" position="left" isConnectable={true} isConnectableStart={false} />

			<NodeHeader
				data={data}
				rest={rest}
				icon={<FaPen />}
				text="Setar valor de variável"
			/>

			<div className="sendMessageContent">
				<div>
					@{data.varToSet} = <b>"{data.valueToset}"</b>
				</div>
			</div>

			<Handle
				type="source"
				position="right"
				className="handle"
				isConnectable={true}
				isValidConnection={ValidatorFn()}
			>
				<FaPlus size={8} style={{ pointerEvents: "none" }} />
			</Handle>
		</>
	);
});
